export const GET_CORPORATES = "GET_CORPORATES";
export const GET_SOURCE_ACCOUNTS = "GET_SOURCE_ACCOUNTS";
